<script>
  import RequiredLabel from '../components/RequiredLabel'
  import AddButton from '../components/AddButton'
  import RemoveButton from '../components/RemoveButton'

  export default {
    name: 'BlockLayout',

    components: {
      RequiredLabel,
      AddButton,
      RemoveButton,
    },

    props: {
      label: {
        type: String,
        default: '',
      },
      comment: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
      showAdd: {
        type: Boolean,
        default: false,
      },
      showRemove: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['add', 'remove'],

    methods: {
      emitAdd() {
        this.$emit('add')
      },

      emitRemove() {
        this.$emit('remove')
      },
    },
  }
</script>

<template>
  <div>
    <div class="collection-header">
      <required-label
        :label="label"
        :comment="comment"
        :required="required"
      />

      <div>
        <add-button
          v-if="showAdd"
          @click="emitAdd"
        />

        <remove-button
          v-if="showRemove"
          @click="emitRemove"
        />
      </div>
    </div>

    <slot />
  </div>
</template>

<style lang="stylus" scoped>
  .collection-header
    display flex
    justify-content space-between
</style>
